/* eslint-disable camelcase */
import { CheckCircle } from '@mui/icons-material'
import {
  Avatar,
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
  IGetSuperAdminChildrenParams,
  ISuperAdminChildren,
} from '../../_models/superAdmin/profileDrawerInterface'
import { PlaceholderImageContainer, SearchWithClose } from '../../components/common'
import { BuildingLatestIcon, SpannerIcon } from '../../components/icons'
import { LineWaveLoader } from '../../components/loader'
import LanguageSelector from './languageSelector'
import ListBusinessProfiles from './listBusinessProfiles'
export const GetSuperAdminProfileDrawerChildren = ({
  completeProfileBusinessList,
  profileBusinessList,
  profileFilters,
  handleSwitchProfile,
  handleConfigurationClick,
  handleScroll,
  isLoadingProfileBusinessList,
  userData,
  active_business_id,
  theme,
  t,
  searchValue,
  setSearchValue,
  debouncedValue,
  handleSearch,
}: IGetSuperAdminChildrenParams): ISuperAdminChildren => {
  return {
    businessHeader: (
      <>
        <Typography
          fontSize='1.25rem'
          color='common.black'
          variant='subtitle1'
          ml={2}
          pt={1}
          pb={0.5}
          sx={{ flexShrink: 0 }}
        >
          {t('superAdminProfileDrawer.businessText')}
        </Typography>
        <Box
          display='flex'
          justifyContent={'flex-start'}
          marginTop={{ xs: '0.5rem', sm: '0.5rem', md: 0 }}
          marginLeft={{ xs: '1rem' }}
        >
          <Box sx={{ marginRight: '1rem' }}>
            <SearchWithClose
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              debouncedValue={debouncedValue}
              handleSearch={handleSearch}
              searchPlaceholder={t('businessManagement.businessNameSearchText')}
              width={{ xs: '20.25rem' }}
              maxHeight={43}
            />
          </Box>
        </Box>
      </>
    ),

    businessList:
      completeProfileBusinessList?.length > 0 ? (
        <InfiniteScroll
          key={completeProfileBusinessList.length}
          dataLength={completeProfileBusinessList.length}
          next={handleScroll}
          hasMore={profileFilters.page < profileBusinessList.last_page}
          loader={<LineWaveLoader />}
          inverse={false}
          scrollableTarget='scrollableDiv'
          endMessage={
            <Typography
              variant='subtitle2'
              fontWeight='400'
              color={theme.palette.publicPages.colorThirteen}
              sx={{ textAlign: 'center', marginTop: 2, marginBottom: 2 }}
            >
              {t('superAdminProfileDrawer.noMoreBusinessText')}
            </Typography>
          }
        >
          <ListBusinessProfiles
            superAdminBusinesses={completeProfileBusinessList}
            switchProfile={handleSwitchProfile}
            superAdmin={true}
          />
        </InfiniteScroll>
      ) : isLoadingProfileBusinessList ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <LineWaveLoader />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <PlaceholderImageContainer
            text={
              searchValue && searchValue?.toString()?.length > 0
                ? t('businessManagement.businessNotFoundPlaceholderText1')
                : t('businessManagement.businessNotFoundPlaceholderText2')
            }
            bordercolor={'transparent'}
            fontSize='0.8rem'
            iconComponent={
              <BuildingLatestIcon
                fill={theme.palette.profileIcon.colorThree}
                width='161'
                height='128'
                backgroundColor={theme.palette.profileIcon.colorFour}
              />
            }
          />
        </Box>
      ),
    superAdminText: (onClose: () => void) => (
      <ListItem disablePadding sx={{ '&:hover .show-on-hover': { display: { sm: 'block' } } }}>
        <ListItemButton
          onClick={() => {
            handleSwitchProfile('super_admin')
            onClose()
          }}
        >
          <ListItemIcon sx={{ mr: 2 }}>
            <Avatar src={userData?.image} alt={userData?.name} />
          </ListItemIcon>
          <ListItemText>
            <Stack
              direction='row'
              justifyContent='space-between'
              sx={{ width: '100%' }}
              alignItems='center'
            >
              <Typography variant='subtitle1' color='description.light' fontWeight='normal'>
                {t('superAdminProfileDrawer.superAdminText')}
              </Typography>
              <Box>
                {/* eslint-disable-next-line camelcase */}
                {userData?.type === 'super_admin' && active_business_id === null ? (
                  <CheckCircle color='success' sx={{ width: 20, height: 20 }} />
                ) : (
                  <Box ml={4} className='show-on-hover' display='none'>
                    <Typography variant='subtitle1' color='primary.main' fontWeight={600}>
                      {t('superAdminProfileDrawer.switchText')}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Stack>
          </ListItemText>
        </ListItemButton>
      </ListItem>
    ),
    menuItems: (onClose: () => void) => {
      if (active_business_id !== null) {
        return null
      }

      return (
        <>
          <ListItem disablePadding onClick={() => handleConfigurationClick(onClose)}>
            <ListItemButton>
              <ListItemIcon sx={{ mr: 2 }}>
                <SpannerIcon width='20' height='20' stoke={theme.palette.publicPages.main} />
              </ListItemIcon>
              <ListItemText>
                <Typography variant='subtitle1' color='description.light' fontWeight={'normal'}>
                  {t('superAdminProfileDrawer.configurationText')}
                </Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton>
              <LanguageSelector />
            </ListItemButton>
          </ListItem>
        </>
      )
    },
  }
}
